// shared-components/context/SiteThemeProvider.jsx
import { useEffect } from "react";
import PropTypes from "prop-types";
import { useWebsite } from "../hooks/useWebsite.ts";
import { applyThemeToDocument } from "../../web/utils/themeUtils";

/**
 * SiteThemeProvider component that applies site-specific theme variables
 * from the WebsiteContext. This works alongside the dark/light mode ThemeProvider.
 */
function SiteThemeProvider({ children }) {
  const websiteConfig = useWebsite();

  useEffect(() => {
    if (websiteConfig.theme) {
      applyThemeToDocument(websiteConfig.theme);
    }
  }, [websiteConfig.theme]);

  return children;
}

SiteThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SiteThemeProvider;
